import { useState } from "react";
import { faqItems } from "@/mocks/faqs";

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFaq = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            <i className="ri-question-answer-line text-secondary-500 mr-2"></i>
            常见问题解答
          </h2>
          <p className="mt-3 text-foreground-600 text-sm">
            快速查找您遇到的问题答案
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.slice(0, 8).map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(faq.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-medium text-foreground-950 text-sm pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`${isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-foreground-400 flex-shrink-0 transition-transform duration-300`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}